import { useTranslation } from "react-i18next";
import { FunctionComponent, useEffect, useState } from "react";
import "./index.scss";
import { Layout, Tabs, TabsProps } from "antd";
import PageHeader from "../../../components/page-header/PageHeader";
import { useParams } from "react-router-dom";
import { useAppStore } from "../../../stores/stores";
import { useLocation } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import AssignedPlanInformation from "../../../components/course-construction/assign-course-construction/assigned-plan-information";
import AssignedDetailedAssignment from "../../../components/course-construction/assign-course-construction/assigned-detailed-assignment";
import AssignedBrowsingResults from "../../../components/course-construction/assign-course-construction/assigned-browsing-results";
import { isEmpty } from "lodash";
import { DetailCourseData } from "../../../types/assign-course-construction";
import { getDetailCourse } from "../../../service/assign-course-construction";

const { Content } = Layout;
const imgPath = '/images/';


const AssignedDetailCourseConstruction: FunctionComponent = () => {
  const { t } = useTranslation();
	const location = useLocation();
	const [tab, setTab] = useState<string>("1");
	const [disableAssign, setdisableAssign] = useState<boolean>(true);
	const [detailData, setDetailData] = useState<DetailCourseData>({
		appraisedDate: "",
		appraisers: [],
		approveName: "",
		approveUserId: 0,
		approvedDate: "",
		assigners: [],
		description: "",
		id: 0,
		name: "",
		isApproved: false,
    isAssigned: false,
    sections: [],
	})
	const { accountInfo, setAccountDetail } = useAppStore((state) => {
		return {
			accountInfo: state?.accountInfo,
			setAccountDetail: state?.setAccountDetail
		}
	})

	const getDetailCourseData = async () => {
		await getDetailCourse(params?.id).then(res => {
			const { data } = res.data
			setDetailData(data)
		})
	}
	useEffect(() => {
		getDetailCourseData()
	}, [])

	const params = useParams()

	const mode = location.state.mode

	const items: TabsProps['items'] =  mode !== 'update' ? [
		{
			key: '1',
			// icon: <UserOutlined />,
			label: t("Thông tin kế hoạch", "Thông tin kế hoạch"),
			children:
				<div className="wrapper">
					<section className="detail-account assigned-course-construction">
						<div className="form-detail">
							<AssignedPlanInformation planInfo={location.state} mode={mode} 
							detailData={detailData} setTab={setTab} setDisableAssign={setdisableAssign} />
						</div>
					</section></div>
		},
		{
			key: '2',
			disabled: disableAssign,
			// icon: <HistoryOutlined />,
			label: t("Phân công chi tiết", "Phân công chi tiết"),
			children:
				<div className="wrapper detail-course-construction">
					<section className="detail-account">
						<div className="form-detail">
							<AssignedDetailedAssignment  mode={mode} detailData={detailData} setTab={setTab} tab={tab}/>
						</div></section>
				</div>
		},
		{
			key: '3',
			// icon: <LockOutlined />,
			label: t("Kết quả duyệt", "Kết quả duyệt"),
			children:
				<div className="wrapper browsing-results">
					<section className="detail-account">
						<div className="form-detail">
							<AssignedBrowsingResults planInfo={location.state} detailData={detailData}/>
						</div>
					</section></div>
		}
	] : [
		{
			key: '1',
			// icon: <UserOutlined />,
			label: t("Thông tin kế hoạch", "Thông tin kế hoạch"),
			children:
				<div className="wrapper">
					<section className="detail-account assigned-course-construction">
						<div className="form-detail">
							<AssignedPlanInformation 
							planInfo={location.state} 
							mode={mode} 
							detailData={detailData} 
							setTab={setTab}
							setDisableAssign={setdisableAssign}/>
						</div>
					</section></div>
		},
		{
			key: '2',
			// icon: <HistoryOutlined />,
			label: t("Phân công chi tiết", "Phân công chi tiết"),
			disabled: disableAssign,
			children:
				<div className="wrapper detail-course-construction">
					<section className="detail-account">
						<div className="form-detail">
							<AssignedDetailedAssignment mode={mode} detailData={detailData} setTab={setTab} tab={tab}/>
						</div></section>
				</div>
		},
	];

	const listBreadcrumb = [
		{
			title: t("Xây dựng khoá học", "Xây dựng khoá học"),
		},
		{
			title: <a href={`/course-construction/${routesConfig.assignCourseConstruction}`}>{t("Phân công xây dựng khoá học", "Phân công xây dựng khoá học")}</a>,
		},
		{
			title: location.state.name,
		},
	]

	return (
		<>
			<Content>
				<PageHeader title={location.state.name} listBreadcrumb={listBreadcrumb} arrowLeft={imgPath + 'arrowLeft.svg'}
					positionItem="column"
					breadcrumb={true}
				/>
				<div className="tabs-heading">
					<Tabs defaultActiveKey="1" items={items} activeKey={tab} onChange={setTab}/>
				</div>
			</Content>
		</>
	);
};

export default AssignedDetailCourseConstruction;
